export class UsuarioConectadoModel {
    constructor(
        public usuarioId: string = "",
        public descricao: string = "",
        public saudacao: string = "",
        public token: string = "",
    ) { }
}
